import { HttpContextToken } from '@angular/common/http';

export const IGNORED_STATUSES = new HttpContextToken<number[]>(() => []);
export const IGNORED_VALUE = -100;
